var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_8734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74994 0H2.24994C1.28497 0 0.5 0.784973 0.5 1.74994V6.24994C0.5 7.21509 1.28497 8.00006 2.24994 8.00006H9.74994C10.7151 8.00006 11.5001 7.21509 11.5001 6.24994V1.74994C11.5001 0.784973 10.7151 0 9.74994 0Z",
    fill: "#3F41D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74994 10H2.24994C1.28497 10 0.5 10.785 0.5 11.7501V22.2501C0.5 23.2151 1.28497 24.0001 2.24994 24.0001H9.74994C10.7151 24.0001 11.5001 23.2151 11.5001 22.2501V11.7501C11.5001 10.785 10.7151 10 9.74994 10Z",
    fill: "#3F41D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7501 16H15.2501C14.285 16 13.5 16.785 13.5 17.7501V22.2501C13.5 23.2151 14.285 24.0001 15.2501 24.0001H22.7501C23.7151 24.0001 24.5001 23.2151 24.5001 22.2501V17.7501C24.5001 16.785 23.7151 16 22.7501 16Z",
    fill: "#3F41D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7501 0H15.2501C14.285 0 13.5 0.784973 13.5 1.74994V12.2499C13.5 13.2151 14.285 14.0001 15.2501 14.0001H22.7501C23.7151 14.0001 24.5001 13.2151 24.5001 12.2499V1.74994C24.5001 0.784973 23.7151 0 22.7501 0Z",
    fill: "#3F41D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_8734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5ae352865f69451ebc81fbdf31da365f.svg";
export { ForwardRef as ReactComponent };